import { Component, OnInit } from '@angular/core';
import { GUI } from '../common/gui';
import { Toast } from '../common/toast';
import { ActivatedRoute } from '@angular/router';
import { HttpUtils } from '../common/http-utils';
import { Constants } from '../common/constants';
import { Utils } from '../common/utils';
import { LoaderService } from '../common/loader-service';
import { LocalStorage } from '../common/local-storage';
import { MemoryStorage } from '../common/memory-storage';
import { Tags } from '../common/tags';

@Component({
  selector: 'app-payment-response',
  templateUrl: './payment-response.component.html',
  styleUrls: ['./payment-response.component.css']
})
export class PaymentResponseComponent implements OnInit {
  private transaction: string = this.constants.BLANK;

  private txnRefNumber: string = this.constants.BLANK;
  private refNumber: string = this.constants.BLANK;

  constructor(private gui: GUI, private toast: Toast, private tags: Tags, private localStorage: LocalStorage, private activatedRoute: ActivatedRoute, private httpUtils: HttpUtils, public constants: Constants, private browserStorageService: MemoryStorage, private utils: Utils, private loaderService: LoaderService) {
    this.activatedRoute.queryParams.subscribe(params => {

      this.txnRefNumber = params['trxref'] || params['TransactionRef'] || null;
      this.refNumber = params['reference'] || null;

    });
    this.clearAuthToken();
    this.checkPaymentStatus();

  }

  ngOnInit(): void {
  }


  private checkPaymentStatus() {
    this.loaderService.startLoader();
    this.httpUtils.verifyPayment(this.txnRefNumber).then(serverResponse => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.toast.showSuccessToast("Your payment has been made successfully.");
        this.gui.openDashboardPage()
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
        this.gui.openDashboardPage()

      }
    });
  }


  private clearAuthToken(): void {
    this.browserStorageService.set(this.tags.APPLICATION_TOKEN, this.localStorage.getSessionStorageKey(this.tags.APPLICATION_TOKEN));
    this.browserStorageService.set(this.tags.AUTHORIZATION, this.localStorage.getSessionStorageKey(this.tags.AUTHORIZATION));
    this.browserStorageService.set(this.tags.KEYCLOAK_TOKEN, this.localStorage.getSessionStorageKey(this.tags.KEYCLOAK_TOKEN));
    this.browserStorageService.set(this.tags.LOGGED_USER_ID, this.localStorage.getSessionStorageKey(this.tags.LOGGED_USER_ID));
    this.browserStorageService.set(this.tags.LOGGED_USER_NAME, this.localStorage.getSessionStorageKey(this.tags.LOGGED_USER_NAME));
    this.browserStorageService.set(this.tags.KEYCLOAK_REFRESH_TOKEN, this.localStorage.getSessionStorageKey(this.tags.KEYCLOAK_REFRESH_TOKEN));

    this.localStorage.removeSessionStorageKey(this.tags.APPLICATION_TOKEN);
    this.localStorage.removeSessionStorageKey(this.tags.AUTHORIZATION);
    this.localStorage.removeSessionStorageKey(this.tags.KEYCLOAK_TOKEN);
    this.localStorage.removeSessionStorageKey(this.tags.LOGGED_USER_ID);
    this.localStorage.removeSessionStorageKey(this.tags.LOGGED_USER_NAME);
    this.localStorage.removeSessionStorageKey(this.tags.KEYCLOAK_REFRESH_TOKEN);

  }

}
